import styled, { keyframes } from "styled-components";
import * as Variables from "../../globalStyles/Variables";
import { clientType } from "../../utils/types";
import { infoFetched } from "../../recoil/Selectors";
import { useRecoilValue } from "recoil";

const Container = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Variables.getColor().background};
  @media ${Variables.device.desktop}{
    padding: 0;
    padding-top: 24px;
  }
`;


const LoadingContainer = styled.div`
  padding-top: 16px;
  display: grid;
    justify-items: center;
    align-items: center;
    gap: 24px;
`;



const rotation = keyframes`
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
`

const Spinner = styled.span`
    width: 24px;
    height: 24px;
    border: 2px solid ${Variables.getColor().textColor}60;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    -webkit-animation: ${rotation} 1s linear infinite;
    animation: ${rotation} 1s linear infinite;
    
    &::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid transparent;
        border-bottom-color: ${Variables.getColor().secondary};
    }

`;

const Logo = styled.img`
    width:80px;
`;

const Loading = () => {

    return (
        <Container>
            <LoadingContainer>
                <Logo src={process.env.REACT_APP_FAV_192} alt="cargando" />
                <Spinner />
            </LoadingContainer>
        </Container>
    );
};

export default Loading;
